export class Legend {
    public lo: LegendQuadrant;
    public midLo: LegendQuadrant;
    public midHi: LegendQuadrant;
    public hi: LegendQuadrant;
    public value: string;
}

export class LegendQuadrant {
    public show: boolean;
    public low: number;
    public high: number;
    public color: string;
}

export enum LegendKey {
    Lo = 1,
    MidLo = 2,
    MidHi = 3,
    Hi = 4
}


// WEBPACK FOOTER //
// C:/WORK/Projects/ActNow_NG2/src/models/map/legend.ts